import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import commonEs from './common.es.json';
import commonEn from './common.en.json';

import authEs from '@features/auth/i18n/es.json';
import authEn from '@features/auth/i18n/en.json';
import dashboardEs from '@features/dashboard/i18n/es.json';
import dashboardEn from '@features/dashboard/i18n/en.json';
import workspacesEs from '@features/workspaces/i18n/es.json';
import workspacesEn from '@features/workspaces/i18n/en.json';
import plansEs from '@features/plans/i18n/es.json';
import plansEn from '@features/plans/i18n/en.json';
import freeCodesEs from '@features/free-codes/i18n/es.json';
import freeCodesEn from '@features/free-codes/i18n/en.json';
import auditEs from '@features/audit/i18n/es.json';
import auditEn from '@features/audit/i18n/en.json';

export const SUPPORTED_LANGUAGES = ['es', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'es';

export const I18N_NAMESPACES = [
  'common',
  'auth',
  'dashboard',
  'workspaces',
  'plans',
  'freeCodes',
  'audit',
] as const;
export type I18nNamespace = (typeof I18N_NAMESPACES)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    ns: I18N_NAMESPACES as unknown as string[],
    defaultNS: 'common',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'gretabot-admin.lang',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: true },
    resources: {
      es: {
        common: commonEs,
        auth: authEs,
        dashboard: dashboardEs,
        workspaces: workspacesEs,
        plans: plansEs,
        freeCodes: freeCodesEs,
        audit: auditEs,
      },
      en: {
        common: commonEn,
        auth: authEn,
        dashboard: dashboardEn,
        workspaces: workspacesEn,
        plans: plansEn,
        freeCodes: freeCodesEn,
        audit: auditEn,
      },
    },
  });

export default i18n;
